/**
 * nodal2.js
 */

document.addEventListener("DOMContentLoaded", function() {

    var selectors = {
        openModal: "nodal--open",
        bodyOpen: "nodal--open",
        nodal: "nodal",
        overlay: "nodal__overlay",
        modalOpenBtn: "nodal-open",
        modalCloseBtn: "nodal-close",
        dataNodalTarget: "data-nodal-target"
    };

    var openModalBtns = document.querySelectorAll("." + selectors.modalOpenBtn);
    var closeModalBtns = document.querySelectorAll("." + selectors.modalCloseBtn);
    var nodalOverlays = document.querySelectorAll("." + selectors.overlay);
    var scrollPosition = 0;

    function openModal(modal) {
        modal.classList.add(selectors.openModal);
        document.body.classList.add(selectors.bodyOpen);
        var modalElements = modal.querySelectorAll("*");
        modalElements.forEach(function(element) {
            element.scrollTop = 0;
        });
        scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        document.body.style.top = "-" + scrollPosition + "px";
    }

    function closeModal(modalContainer) {
        modalContainer.classList.remove(selectors.openModal);
        document.body.classList.remove(selectors.bodyOpen);
        document.body.style.top = "0";
        window.scrollTo(0, scrollPosition);
    }

    openModalBtns.forEach(function(openModalBtn) {
        openModalBtn.addEventListener("click", function(event) {
            var nodalTarget = this.getAttribute(selectors.dataNodalTarget);
            var modal = document.querySelector("." + nodalTarget) || document.getElementById(nodalTarget);
            if (modal) {
                openModal(modal);
            }
            event.preventDefault();
        });
    });

    closeModalBtns.forEach(function(closeModalBtn) {
        closeModalBtn.addEventListener("click", function(event) {
            var modalContainer = closeModalBtn.closest("." + selectors.nodal);
            closeModal(modalContainer);
            event.preventDefault();
        });
    });

    nodalOverlays.forEach(function(nodalOverlay) {
        nodalOverlay.addEventListener("click", function(event) {
            var modalContainer = nodalOverlay.closest("." + selectors.nodal);
            if (event.target === nodalOverlay) {
                closeModal(modalContainer);
            }
            event.preventDefault();
        });
    });

});
